<template>
    <span :class="['badge', `badge-${size}`, `badge-${color}`]">
      {{ label }} 
    </span>
  </template>
  <script>
  export default {
    name: "BadgeTipoAcesso",
    props: {
      tipoAcesso: {
        type: [Number],
        default: 1
      },
      size: {
        type: String,
        default: 'md'
      }
    },
    computed: {
        label() {
            const labels = {
                1: 'Implantação',
                2: 'Upsell',
                3: 'Downsell',
            }
            return labels[this.tipoAcesso];
        },
        color() {
            const colors = {
                1: 'primary',
                2: 'info',
                3: 'dark',
            }
            return colors[this.tipoAcesso];
        }
    }
  }
  </script>
  